export const SET_CURRENT_TEAMS = "SET_CURRENT_TEAMS";
export const SET_CURRENT_TEAMS_COMPLETE = "SET_CURRENT_TEAMS_COMPLETE";
export const SAVE_TEAM = "SAVE_TEAM";
export const SAVE_TEAM_COMPLETE = "SAVE_TEAM_COMPLETE";
export const RESET_CURRENT_TEAMS = "RESET_CURRENT_TEAMS";
